module.exports = __webpack_public_path__ + "static/media/pickupmap-north-las-vegas.fa29227d.jpg";